import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import {
  BaseAssessment,
  RemoveAssessmentAssignmentRequestModel,
} from 'types/api';
import { useAuthenticatedFetch } from 'hooks/util/useAuthenticatedFetch';
import { apiUrl } from 'util/apiUrl';

export const useDeleteAssessmentOwner = () => {
  const fetch = useAuthenticatedFetch();
  return useMutation(
    (body: RemoveAssessmentAssignmentRequestModel) =>
      fetch<BaseAssessment[]>(`${apiUrl}/assessments/owners`, {
        body,
        method: 'DELETE',
      }),
    {
      onError: () => {
        toast.error('Error detaching organization.');
      },
      onSuccess: () => {
        toast.success('Organization detached.');
      },
    },
  );
};
